import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'linked-text',
    templateUrl: 'cmn-linked-text.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

/*
 * Takes text and replaces the anchor tags with the values in the links array. 
 * To use: put anchor tags in your text and pass in the link URLs. This can only
 * handle a single anchor tag. To handle multiple tags in a text, split the text 
 * 
 * If a function is passed in it will be called on
 * click. If a string is passed in it will use the href attribute.
 */
export class CmnLinkedTextComponent implements OnInit {
    
    readonly anchorStart : string = '<a>';
    readonly anchorEnd : string = '</a>';
    
    // Array list of tags considered to be hyperlinks, to be replaced by anchor tag
    tags : Array<string> = new Array<string>('<link>');
        
    @Input() linkClass : string;
    @Input() link : string | (() => void);
    get linkFn(): () => void {
        return this.link as () => void;
    }
    @Input() set text(_text : string) {
        this.evaluateLink(_text);
    }
    @Input() target : string = "";
    
    showHref : boolean = false;
    showOnClick : boolean = false;
    showTextOnly : boolean = true;
    textArray : Array<string> = new Array<string>();
    
    preLinkText : string = "";
    linkTxt : string = "";
    postLinkText : string = "";
    
    ngOnInit() : void {
    }
    
    evaluateLink(text : string) : void {
      
        if (text !== undefined && text != null) {
            for (let startTag of this.tags) {
                
                let endTag = startTag.replace('<', '</');
                
                if (text.includes(startTag) && text.includes(endTag)) {
                    text = text.replace(startTag, this.anchorStart);
                    text = text.replace(endTag, this.anchorEnd);
                    break;
                }
            }
        
            if (text.includes(this.anchorStart)) {
                let startIndex : number = text.indexOf(this.anchorStart);
                let endIndex : number = text.indexOf(this.anchorEnd);
                let tagLength : number = this.anchorStart.length;
                let endTagLength : number = this.anchorEnd.length;
                
                this.preLinkText = text.slice(0, startIndex);
                this.linkTxt = text.slice(startIndex + tagLength, endIndex);
                this.postLinkText = text.slice(endIndex + endTagLength);
                
                this.textArray = new Array<string>();
                this.textArray.push(this.preLinkText);
                this.textArray.push(this.linkTxt.trim());
                this.textArray.push(this.postLinkText);
                
                if(typeof this.link == "string") {
                    this.showHref = true;
                    this.showOnClick = false;
                } else if(typeof this.link == "function") {
                    this.showHref = false;
                    this.showOnClick = true;
                }
                          
            } else {
              this.textArray.push(text);
              this.textArray.push('');
              this.textArray.push('');
            }
        }
    }
    
    prefix(): string {
        return this.preLinkText;
    }
    
    linkText(): string {
        return this.linkTxt;
    }
    
    suffix(): string {
        return this.postLinkText;
    }
    
    textOnly(): string {       
       return this.preLinkText + 
              this.linkTxt +             
              this.postLinkText;  
    }
    
}